import { render } from "./EndRedirect.vue?vue&type=template&id=058da3e6&ts=true"
import script from "./EndRedirect.vue?vue&type=script&lang=ts"
export * from "./EndRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/EndRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "058da3e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('058da3e6', __exports__)) {
    api.reload('058da3e6', __exports__)
  }
  
  module.hot.accept("./EndRedirect.vue?vue&type=template&id=058da3e6&ts=true", () => {
    api.rerender('058da3e6', render)
  })

}


export default __exports__